import styled from 'styled-components'
import Link from './Link'
import extractLinkitParts from '../lib/extractLinkitParts'
import Container from './layout/Container'
import Stack from './layout/Stack'
import textLink from '../styles/textLink'

function LinksSection( { sectionTitle = null, links } ) {
  const st = sectionTitle || 'Investigation Highlights'

  const titleMaxWidth = st.length > 20 && st.length < 30
    ? '14rem'
    : 'none'

  return (
    <Container>
      <Stack
        top={ 4 }
        bottom={ 4 }
      >
        <StyledLinksSection $titleMaxWidth={ titleMaxWidth }>
          <div>
            <h2>{ st }</h2>
          </div>
          <div>
            <StyledLinks>
              { links.map( link => <TheLink key={ link.id } link={ link } /> ) }
            </StyledLinks>
          </div>
        </StyledLinksSection>
      </Stack>
    </Container>
  )
}

function TheLink( { link } ) {
  const {
    url, text, target, rel, 
  } = extractLinkitParts( link.theLink.link )

  return (
    <Link 
      href={ url }
      target={ target }
      rel={ rel }
    >
      { text }
      <div>
        <span>{ link.linkInfo }</span>
      </div>
    </Link>
  )
}

interface StyledLinksSection {
  $titleMaxWidth: string,
}

const StyledLinksSection = styled.footer<StyledLinksSection>`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 -1rem;

  > div {
    margin: 0 1rem;
  }

  h2 {
    max-width: ${ p => p.$titleMaxWidth };
    margin: 0 1rem 2rem 0;
    ${ p => p.theme.typo.generalSansSemiBold }
    font-size: ${ p => p.theme.typo.sizes.medium };
    color: ${ p => p.theme.colors.red };
  }

  @media ( min-width: 800px ) {
    grid-template-columns: 33.333% 1fr;
  }
`

const StyledLinks = styled.div`
  columns: 300px 2;
  column-gap: 2rem;

  a {
    display: block;
    column-break-inside: avoid;
    margin-bottom: 1.8rem;
    ${ p => p.theme.typo.generalSansSemiBold }
    font-size: ${ p => p.theme.typo.sizes.normal };
    line-height: 1.35;
    color: ${ p => p.theme.colors.black };
    ${ textLink }
    text-decoration-color: ${ p => p.theme.colors.black };
    transition: text-decoration-color .3s ease-out;

    span {
      display: inline-block;
      margin-top: 1rem;
      ${ p => p.theme.typo.rowan }
      color: ${ p => p.theme.colors.red };
      text-decoration: none;
    }

    &:hover {
      text-decoration-color: ${ p => p.theme.colors.red };
    }
  }
`

export default LinksSection
